import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(cohortId) {
    return `${window.api_url}/shared/cohorts/${cohortId}/learners`;
  },

  // Create multiple learners with statistics
  async create(cohortId, memberIds) {
    const payload = {
      member_ids: Array.isArray(memberIds) ? memberIds : [memberIds],
    };

    return axios.post(this.baseUrl(cohortId), payload).catch(handleError);
  },

  // Destroy single learner
  async destroy(cohortId, memberId) {
    try {
      const response = await axios.delete(`${this.baseUrl(cohortId)}/${memberId}`);
      return response;
    } catch (error) {
      handleError(error);
      throw error;
    }
  },
};
